// eslint-disable-next-line max-classes-per-file
export class SideNavigationMenuTogglingEvent {
  static readonly type = '[Core] Side Navigation Menu Toggling'
}

export class SideNavigationMenuToggledEvent {
  static readonly type = '[Core] Side Navigation Menu Toggled'
}
